import { OwaDate, owaDate, userDate } from 'owa-datetime';

export default function getDueDate(
    date: string | undefined,
    tz: string | undefined
): OwaDate | undefined {
    return date && tz ? userDate(owaDate(tz, date)) : undefined;
}
